import ScheduleButton from "../ScheduleComponent/ScheduleButton.jsx";
import ScheduleData from "../../hook/ScheduleData";

function TeacherSchedule() 
{
 const { data: scheduleData, loading, error } = ScheduleData('/Teacher');

    if (loading) return <div className='loading'>Загрузка...</div>;
    if (error) return <div className='error'>Ошибка: {error.message}</div>;

    return (
        <ScheduleButton 
        data={scheduleData}
        url="teachers"
        title="Расписание преподавателей"
        displayKey="teacher"
        routeKey="teacher"
        keyField="teacherName"
    />)
}

export default TeacherSchedule;